<template>
  <div>
    <a-spin :spinning="loading">
      <div class="searchContainer" ref="searchRef">
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.doctorId"
            size="large"
            placeholder="医生ID"
            allowClear
            @input="inputFormat($event, 'doctorId', 3)"
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.doctorName"
            size="large"
            placeholder="医生姓名"
            allowClear
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="doSearch">
            搜索
          </a-button>
        </div>
      </div>
      <div class="data_wrap">
        <div class="header">
          <div class="title">
            <span class="role">患者</span>
            <span>{{ params.patientName }}</span>
            <span class="phone">{{ params.patientPhone }}</span>
            <auth-img :src="see_detail" @click="seeInfo(params.patientId, 1)" />
          </div>
          <div class="tips">
            注意：为了后期更好的追溯辅导BD的工作留痕，请拨打角色电话时确定绑定的BD/医生/患者信息是否对称
          </div>
        </div>
        <a-table
          class="table"
          :pagination="pagination"
          :rowKey="(record, index) => index"
          :columns="columns"
          :data-source="tableData"
          @change="onChangePage"
          :scroll="{ x: `calc(100% - 40px)` }"
          :transformCellText="({ text }) => text ?? '--'"
        >
          <template #patientName="{ record }">
            {{ record.patientName || '--' }}
            <a-tooltip
              placement="bottomLeft"
              v-if="record.blackFlag"
              :title="`被医生拉黑名单，日期：${record.blackTime}`"
            >
              <span class="action-trigger">
                <QuestionCircleOutlined :style="{ color: '#999', marginLeft: '6px' }" />
              </span>
            </a-tooltip>
          </template>
          <template #patientPhone="{ record }">
            <span v-if="record.patientPhone">
              <!-- <span class="link_content" @click="callFn(record, 1)"> -->
              <span class="">
                {{ record.patientPhone }}
                <!-- <auth-img :src="call_icon" class="see_detail" /> -->
              </span>
              <auth-img
                :src="see_detail"
                class="see_detail"
                @click="seeInfo(record.patientId, 1)"
              />
            </span>
            <span v-else>--</span>
          </template>
          <template #doctorPhone="{ record }">
            <span v-if="record.doctorPhone">
              <!-- <span class="link_content" @click="callFn(record, 2)"> -->
              <span class="">
                {{ record.doctorPhone }}
                <!-- <auth-img :src="call_icon" class="see_detail" /> -->
              </span>
              <auth-img :src="see_detail" class="see_detail" @click="seeInfo(record.doctorId, 2)" />
            </span>
            <span v-else>--</span>
          </template>
          <template #bdPhone="{ record }">
            <span v-if="record.bdPhone">
              <!-- <span class="link_content" @click="callFn(record, 3)"> -->
              <span class="">
                {{ record.bdPhone }}
                <!-- <auth-img :src="call_icon" class="see_detail" /> -->
              </span>
              <auth-img :src="see_detail" class="see_detail" @click="seeInfo(record.bdId, 3)" />
            </span>
            <span v-else>--</span>
          </template>
          <template #handler="{ record }">
            <span class="link_content btn" @click="viewDetailsGroup(record, 2)">查看会话</span>
            <span
              class="link_content btn"
              @click="viewDetailsGuide(record, 2)"
              :class="{
                disabled: !record.guideConsultGroupId || record.guideConsultGroupId == '0'
              }"
            >
              导诊记录
            </span>
            <span class="link_content btn" @click="viewDetails(record, 11)">通话记录</span>
          </template>
        </a-table>
      </div>
    </a-spin>
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
      :activeTab="activeTab"
    />
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, defineProps, watch, defineEmits } from 'vue'
import { paginationConfig, columns } from './config'
import { inputRule } from '@/utils/validate'
import { getPatientDetail, getUserInfoByType } from '@/api/UserPool'
import see_detail from '@/assets/img/see_detail.png'
import call_icon from '@/assets/img/callout.png'
import { call } from '@/views/UserPool/hooks/useCall'
import PatientInfoDetails from '@/components/OldPatientInfoDetails'
import { QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons-vue'

const searchRef = ref(null)
const loading = ref(false)
const emits = defineEmits(['seeInfo'])
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
})

const defaultQuery = {
  doctorName: '',
  doctorId: null
}
const listQuery = reactive({ ...defaultQuery })
const pagination = reactive({ ...paginationConfig })
watch(
  () => props.params,
  val => {
    Object.assign(listQuery, defaultQuery)
    Object.assign(pagination, paginationConfig)
    listQuery.patientName = val.patientName
    listQuery.ucPatientId = val.ucPatientId
    searchList()
  },
  {
    immediate: true,
    deep: true
  }
)
const tableData = ref([])
function resetQuery() {
  Object.assign(listQuery, defaultQuery)
  Object.assign(pagination, paginationConfig)
  searchList()
}
function doSearch() {
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  searchList()
}
function searchList() {
  if (!listQuery?.ucPatientId) return
  loading.value = true
  const params = {
    ...listQuery,
    pageNo: pagination.current,
    pageSize: pagination.pageSize
  }
  getPatientDetail(params)
    .then(res => {
      const { list = [], totalCount } = res
      tableData.value = list
      pagination.total = totalCount
      pagination.showTotal = () => `共${totalCount}条`
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
function inputFormat(e, key, type) {
  listQuery[key] = inputRule(e.target.value, type)
}
const onChangePage = page => {
  pagination.current = page.current
  pagination.pageSize = page.pageSize
  searchList()
}
const seeInfo = (id, type) => {
  emits('seeInfo', id, type)
}
const callFn = (record, type) => {
  const params = {
    accountType: type,
    id: null
  }
  let ucUserId = null
  const arr = ['', '患者', '医生', 'BD']
  switch (type) {
    case 1:
      params.id = record.patientId
      ucUserId = record.ucPatientId
      break
    case 2:
      params.id = record.doctorId
      ucUserId = record.ucDoctorId
      break
    case 3:
      params.id = record.bdId
      ucUserId = record.ucBdId
      break
  }
  getUserInfoByType(params).then(res => {
    const { name } = res
    const query = {
      calleeName: name,
      calleeRole: arr[type],
      calleeType: type,
      calleeUcUserId: ucUserId,
      doctorId: record.doctorId
    }
    console.log(query)
    call(query)
  })
}
const showAllDialog = ref(false)
const currentInfo = ref({})
const activeTab = ref(null)
// 三方群
const viewDetailsGroup = (record, key) => {
  const newRecord = JSON.parse(JSON.stringify(record))
  newRecord.guideConsultGroupId = ''
  viewDetails(newRecord, key)
}
// 导诊群
const viewDetailsGuide = (record, key) => {
  const { guideConsultGroupId } = record
  if (!guideConsultGroupId || guideConsultGroupId === '0') return
  viewDetails(record, key)
}
const viewDetails = (record, key) => {
  showAllDialog.value = true
  currentInfo.value = record
  activeTab.value = key
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
</script>
<style scoped lang="scss">
.searchContainer {
  background-color: #fff;
  .search-item {
    display: inline-block;
    margin-right: 12px;
    margin-bottom: 24px;
    .search_icon {
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
.data_wrap {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  .title {
    padding: 5px 7px;
    background: #ffa9401a;
    border-radius: 4px;
    width: fit-content;
    line-height: initial;
    display: flex;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin-right: 8px;
    }
    .role {
      border: 1px solid #ffa940;
      border-radius: 4px;
      padding: 1px 4px;
      font-size: 12px;
      color: #ffa940;
    }
    .phone {
      border-left: 2px solid #333333;
      padding-left: 8px;
    }
    img {
      margin-right: 8px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: #f5222d;
  }
  .btn {
    padding-right: 16px;
    &.disabled {
      cursor: no-drop;
      color: #333333;
    }
  }
  .see_detail {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    cursor: pointer;
  }
}
</style>
